export function formatReportResultColumnAccessor(str: string): string {
  return str.replaceAll('.', '').replaceAll('/', '').replaceAll(' ', '').toLowerCase();
}
export default formatReportResultColumnAccessor;
